import { render, staticRenderFns } from "./addProductType.vue?vue&type=template&id=2e0aac24&scoped=true&"
import script from "./addProductType.vue?vue&type=script&lang=js&"
export * from "./addProductType.vue?vue&type=script&lang=js&"
import style0 from "./addProductType.vue?vue&type=style&index=0&id=2e0aac24&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0aac24",
  null
  
)

export default component.exports